import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=e1135916&scoped=true"
import script from "./ViewTable.vue?vue&type=script&lang=js"
export * from "./ViewTable.vue?vue&type=script&lang=js"
import style0 from "./ViewTable.vue?vue&type=style&index=0&id=e1135916&lang=scss"
import style1 from "./ViewTable.vue?vue&type=style&index=1&id=e1135916&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1135916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1135916')) {
      api.createRecord('e1135916', component.options)
    } else {
      api.reload('e1135916', component.options)
    }
    module.hot.accept("./ViewTable.vue?vue&type=template&id=e1135916&scoped=true", function () {
      api.rerender('e1135916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/ViewTable.vue"
export default component.exports